module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-dark-screens-2.9d5e087c.png";